<template>
  <svg width="20" height="12" viewBox="0 0 20 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M20 1.23888L7.39306 12L0 5.28039L1.3222 4.07861L7.43391 9.63359L18.7199 0L20 1.23888Z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default {
  name: "CheckIcon"
}
</script>
